import { dashboardReducer } from "./dashboard";
import { appStateReducer } from "./app";
import { combineReducers } from "redux";

export const appReducer = combineReducers({
  dashboard: dashboardReducer,
  appState: appStateReducer,
});
